import moment from "moment";
import { call, put, takeLatest } from "redux-saga/effects";
import { getReferalInformationSuccess, GET_REFERAL_INFORMATION_REQUEST, GET_SCHEDULE_DEVICE_REQUEST, postAppointmentSuccess, postReferalInformationRequest, POST_APPOINTNET_FAILURE, POST_APPOINTNET_REQUEST, POST_SCHEDULE_DEVICE_REQUEST, PUT_APPOINTNET_REQUEST, getAppointmentRequest, getAllAppointmentRequest } from "../actions/patientAction";
import { createAppointmentAPICall, createScheduleDeviceAPICall, getReferralDetailsAPICall, putAppointmentAPICall, putReferralDetailsAPICall, scheduleDeviceAPICall } from "../apis/appointmentApi";
import { checkAuthorizationError, errorNotification, successNotification } from "../utils/notification-helpers";
import AuthService from "../services/AuthService";
import history from "../routers/history";
import { getAppointmentDetailAPICall } from "../apis/patientCallApi";
import { isArray } from "lodash";

const auth = new AuthService()

function * createAppoinmtentHandler ({ payload }) {
  try {
    const { userBasicInfo } = auth.getProfile()

    const { presence_of_the_person, modality, appointmentdate, profile_id, createPatient, facility_id, afterSuccess, urgent, visit_time, procedure_id, duration, appointment_status } = payload || {}
    
    if(createPatient){
      const { responseStatus, responseJSON } = yield call(createAppointmentAPICall,{
        modality: modality,
        procedure_id: procedure_id.length > 0 ? procedure_id.filter((value, index) => value && value !== null) : null,
        appointment_status,
        appointment_date_time: appointmentdate || moment().unix(),
        patient_id : createPatient?.patient_id,
        phone_number: createPatient?.phone,
        name: createPatient?.name ? createPatient?.name : createPatient?.first_name + " " + createPatient?.middle_name + " " + createPatient?.last_name,
        email: createPatient?.email,
        visit_time: visit_time ? moment(visit_time)?.format() : moment().format(),
        presence_of_the_person: presence_of_the_person,
        source_application: "FrontDesk App" ,
        facility_id: facility_id,
        duration: duration,
        urgent: urgent,
      })
      if(responseStatus >= 200 && responseStatus < 300){
        if(afterSuccess){
          afterSuccess(false)
        }
        successNotification("Appointment is created")
        yield put(postAppointmentSuccess(responseJSON))
        history.push("/")
      } else if(responseStatus === 401){
        throw Error(responseStatus);
      }
    } else {
      if(afterSuccess){
        afterSuccess(false)
      }
      errorNotification("Patient not found")
    }
  } catch (e) {
    console.error(e)
    yield put({
      type: POST_APPOINTNET_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}


function * putAppoinmtentHandler ({ payload }) {
  try {
    const { facility_id, profile_id, afterSuccess, currentTab, isNotPatientTable, first_name, middle_name, last_name, name, procedure_id, patient_name } = payload;
    let newData = {
      ...payload,
      procedure_id: isArray(procedure_id) ? procedure_id.filter((value, index) => value && value !== null) : [procedure_id],
      name: name || patient_name || first_name ? name || first_name + " " + middle_name + " " + last_name  : undefined,
    }

    const appointmentDate = moment.unix(payload.appointment_date_time).format("DD/MM/YYYY")
    const appointmentTime = moment(payload.visit_time).format("HH:mm")
    const appointmentDateTimeString = `${appointmentDate} ${appointmentTime}`
    const appointmentDateTimeMoment = moment(appointmentDateTimeString, "DD/MM/YYYY HH:mm")
    const appointmentDateTime = appointmentDateTimeMoment.unix()
    newData.appointment_date_time = appointmentDateTime
    newData.visit_time = appointmentDateTimeMoment
    const { responseStatus, responseJSON } = yield call(putAppointmentAPICall, newData)
    if(responseStatus >= 200 && responseStatus < 300){
      successNotification("Appointment is updated")
      if(isNotPatientTable){
        yield put(getAllAppointmentRequest({ profile_id, facility_id: [facility_id], currentTab: currentTab }))
        
      }else{
        yield put(getAppointmentRequest({ profile_id, facility_id: [facility_id], currentTab }))
      }
      if(afterSuccess){
        history.goBack()
        afterSuccess(false)
      }
      // yield put(postAppointmentSuccess(responseJSON))
    } else if(responseStatus === 401){
      throw Error(responseStatus);
    } else if (responseStatus >= 400 && responseStatus < 500) {
      if(afterSuccess){
        afterSuccess(false)
      }
    }
  } catch (e) {
    console.error(e)
    yield put({
      type: POST_APPOINTNET_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}


function * getRefferalDetailsHandler ({ payload }) {
  try {
    const { patient_id, phone_number, referring_facility, referring_physician, onlyData, externalPhyscian, internalPhysician, externalSourceFacility, internalSourceFacility, afterSuccess, returnPage }= payload || {}

    let referringPhysician = referring_physician && referring_physician[0] === 'external-physician-guid' ?  externalPhyscian : internalPhysician;
    let referringFacility = referring_facility && referring_facility[0] === 'external-facility-guid' ?  externalSourceFacility : internalSourceFacility


    const { responseStatus, responseJSON } = yield call(getReferralDetailsAPICall , {patient_id: patient_id})
    if(responseStatus >= 200 && responseStatus < 300){
      yield put(getReferalInformationSuccess(responseJSON[0]))
      if(!onlyData){
        if(afterSuccess){
          afterSuccess(false)
        }
        yield put(putReferralDetailsAPICall({
          ...responseJSON[0],
          referring_facility: referringFacility?.find(value=> value.guid === referring_facility[1])?.name,
          referring_physician: referringPhysician?.find(value=> value.guid === referring_physician[1]).full_name,
          physician_name: referringPhysician?.find(value=> value.guid === referring_physician[1]).full_name,
          physician_id: referring_physician[1],
          phone_number: phone_number ? phone_number: responseJSON[0].phone_number, email: referringPhysician?.find(value=> value.guid === referring_physician[1])?.email , id: responseJSON[0]?.id
        }))
      }
    } else if (responseStatus === 404) {
      yield put(getReferalInformationSuccess([]))
      if(!onlyData){
        yield put(postReferalInformationRequest({...payload, updated: true}))
      }
    } else if(responseStatus === 401){
      throw Error(responseStatus);
    }
    if(returnPage) history.goBack()
  } catch (e) {
    console.error(e)
    yield put({
      type: POST_APPOINTNET_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}


function * scheduleDeviceHandler ({ payload }) {
  try {
    const { responseStatus, responseJSON } = yield call(scheduleDeviceAPICall, payload)
    if(responseStatus >= 200 && responseStatus < 300){
      yield put(postAppointmentSuccess(responseJSON))
    } else if(responseStatus === 401){
      throw Error(responseStatus);
    }

  } catch (e) {
    console.error(e)
    yield put({
      type: POST_APPOINTNET_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}

function * createScheduleDeviceHandler ({ payload }) {
  try {
    // const { userBasicInfo } = auth.getProfile()

    const { responseStatus, responseJSON } = yield call(createScheduleDeviceAPICall, ...payload)
    if(responseStatus >= 200 && responseStatus < 300){
      // yield put(postAppointmentSuccess(responseJSON))
    } else if(responseStatus === 401){
      throw Error(responseStatus);
    }

  } catch (e) {
    console.error(e)
    yield put({
      type: POST_APPOINTNET_FAILURE,
      message: e.message
    })
    checkAuthorizationError(e.message)
  }
}


  export function * appointmentSaga () {
    yield takeLatest(GET_REFERAL_INFORMATION_REQUEST, getRefferalDetailsHandler)
    yield takeLatest(POST_APPOINTNET_REQUEST, createAppoinmtentHandler)
    yield takeLatest(PUT_APPOINTNET_REQUEST, putAppoinmtentHandler)
    yield takeLatest(GET_SCHEDULE_DEVICE_REQUEST, scheduleDeviceHandler)
    yield takeLatest(POST_SCHEDULE_DEVICE_REQUEST, createScheduleDeviceHandler)
}